import React, { Component } from 'react';
/* import ApiBitcoin from '../../utils/api.bitcoin'; */

class ShowValue extends Component {
  ticker;
  _ismounted;

  constructor(props) {
    super(props);

    /* btc: parseFloat(this.props.btc).toLocaleString('pt'), */

    this.state = {
      btc : this.props.btc,
      dollar: '',
      ticker: undefined
    };

    /*if(sessionStorage.getItem('ticker')) {
      this.state.ticker = JSON.parse(sessionStorage.getItem('ticker'));
    }*/

    /*
    if(!this.state.ticker) {
      new ApiBitcoin().get().then(response => {
        if(response.data) {
          sessionStorage.setItem('ticker', JSON.stringify(response.data));
          this.state.ticker = response.data;
          this._loadDollarValue();
        }
      });
    } else {this._loadDollarValue(props.btc);}
      */
  }

  componentDidMount() { 
    this._ismounted = true;
  }
  
  UNSAFE_componentWillUnmount() {
     this._ismounted = false;
  }

  _loadDollarValue(btc) {
    if(this.state.ticker) {
      let finalValue = parseFloat(btc / 100).toFixed(2);

      if(!this._ismounted) {
        this.setState(...this.state, {
          dollar:  'R$ ' + finalValue
        });
      } else {
        this.setState(...this.state, {
          dollar: 'R$ ' + finalValue
        });
      }
    }
  } 

  render() {
    return (
      <span className={ this.props.className }>
          {/* { this.state.btc } Sats
        <br hidden={ this.props.withoutBreak } /> 
        <span hidden={ !this.props.withoutBreak }> / </span>  */}
          R${parseFloat(this.state.btc / 100).toFixed(2)}
      </span>
    );
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(...this.state, {
      btc: parseFloat(props.btc).toFixed(2),
      dollar: ''
    });

    /*this._loadDollarValue(props.btc);*/
  }
}

export default ShowValue;


// WEBPACK FOOTER //
// ./src/components/ShowValue/index.js